fragment Map on mapBlockBlock_Entry {
    description
    markers {
        
            ... on marker_Entry {
                markerTitle
                longitude
                latitude
                enabled
                markerDescription
                markerLinkExternal
                markerLink {
                    ... on EntryInterface {
                        uri
                    }
                }
            }
        
    }
}